<template>
  <b-modal
    id="reversetransaction-modal"
  >
    <h4 class="text-center">
      Are you sure you want to reverse this transaction?
    </h4>
    <template #modal-footer="{ close }">
      <b-row style="width:100%">
        <b-col md="6">
          <b-button
            block
            variant="danger"
            @click="close"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col md="6">
          <b-button
            block
            variant="primary"
            :disabled="submitting"
            @click="reverseHandler"
          >
            <BSpinner
              v-if="submitting"
              small
            />
            <span v-else>Confirm</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BButton, BSpinner, BRow, BCol,
} from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'

export default {
  components: {
    BModal, BButton, BSpinner, BRow, BCol,
  },
  props: {
    id: {
      type: String,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const submitting = ref(false)
    const id = computed(() => props?.id)
    const reverseHandler = async () => {
      try {
        submitting.value = true
        await ctx.root.$store.dispatch('driverView/reverseTransaction', id.value)
        ctx.emit('reversed')
        ctx.root.$bvModal.hide('reversetransaction-modal')
      } finally {
        submitting.value = false
      }
    }
    return {
      submitting,
      reverseHandler,
    }
  },
}
</script>

<style></style>
